import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Field } from "@/components/site/FormControls";
import { adminApi, apiError } from "@/lib/api";
import { useAdminUser, startGoogleLogin, AdminShell } from "@/lib/adminAuth";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [user] = useAdminUser();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await adminApi.post("/auth/login", f);
      navigate("/admin");
    } catch (ex) {
      setErr(apiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminShell>
      <div className="mx-auto max-w-md px-4 py-16">
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-2xl border border-slate-200 bg-white p-8">
          <h1 className="font-display text-2xl font-bold text-[#0B132B]">Admin sign in</h1>
          <p className="mt-1 text-sm text-slate-500">Inspection management dashboard</p>
          <div className="mt-6 grid gap-4">
            <Field label="Email" name="email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required testid="admin-login-email" />
            <Field label="Password" name="password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required testid="admin-login-password" />
          </div>
          {err && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-600">{err}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#0B132B] py-3 text-sm font-semibold text-white hover:bg-gold hover:text-[#0B132B] disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
          <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" /> or <span className="h-px flex-1 bg-slate-200" /></div>
          <button type="button" onClick={startGoogleLogin} data-testid="admin-google-login"
            className="w-full rounded-full border border-slate-300 py-3 text-sm font-semibold text-[#0B132B] hover:border-gold">
            Continue with Google
          </button>
          <Link to="/admin/forgot-password" data-testid="admin-forgot-link" className="mt-5 block text-center text-sm text-slate-500 underline underline-offset-4">Forgot password?</Link>
        </form>
      </div>
    </AdminShell>
  );
}
